module.exports = __webpack_public_path__ + "static/media/g-4-d.439bdbbf.jpg";